import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import {
  HelpButton,
  HelpIntro,
  HelpScreen,
  HelpSection,
  InfoNote,
} from "@/components/help/help-ui";

const reportable = () => [
  i18n.t("help.report.items.bugs"),
  i18n.t("help.report.items.harassment"),
  i18n.t("help.report.items.profiles"),
  i18n.t("help.report.items.spam"),
  i18n.t("help.report.items.payment"),
  i18n.t("help.report.items.features"),
  i18n.t("help.report.items.other"),
];

export default function ReportProblem() {
  useTranslation();
  const router = useRouter();

  return (
    <HelpScreen title={i18n.t("help.report.title")}>
      <HelpIntro>{i18n.t("help.report.intro")}</HelpIntro>

      <HelpSection
        heading={i18n.t("help.report.heading")}
        bullets={reportable()}
      />

      <InfoNote icon="lock-closed-outline">
        {i18n.t("help.report.private")}
      </InfoNote>

      <HelpButton
        label={i18n.t("help.report.start")}
        icon="flag-outline"
        onPress={() => router.push("/help/contact?source=report")}
      />
    </HelpScreen>
  );
}
